import type { AppMessages } from '../../types';

export const app: AppMessages = {
  common: {
    loading: 'Cargando...',
    saving: 'Guardando...',
    save: 'Guardar',
    back: 'Volver',
    error: 'Error',
    notSet: 'No definido',
    user: 'Usuario',
    system: 'Sistema',
    copied: '¡Copiado!',
    copy: 'Copiar',
    cancel: 'Cancelar',
    creating: 'Creando...',
    processing: 'Procesando...',
    you: 'Tú',
    stars: 'Stars',
    seeAll: 'Ver todo',
    filter: 'Filtrar',
    amount: 'Importe',
    date: 'Fecha',
    details: 'Detalles',
    mustBeLoggedIn: 'Debes iniciar sesión',
    daysShort: 'd',
    hoursShort: 'h',
    minutesShort: 'min',
    justNow: 'Ahora mismo',
    noTitle: 'Sin título',
    payment: 'pago',
    payments: 'pagos',
  },
  layout: {
    dashboard: 'Panel',
    invoices: 'Facturas',
    ledger: 'Libro mayor',
    withdraws: 'Retiros',
    redirects: 'Redirecciones',
    settings: 'Ajustes',
    admin: 'Admin',
    profile: 'Perfil',
    logout: 'Cerrar sesión',
    tonConfigured: 'TON configurado',
    configureTon: 'Configurar TON',
    tonNotConfigured: 'Dirección TON no configurada',
    active: 'Activo',
    walletConnect: 'Conectar wallet',
    walletTitle: 'Conecta tu wallet TON',
    walletSubtitle: 'Introduce la dirección TON que recibirá tus retiros.',
    walletConnectedTitle: 'Wallet conectada',
    walletConnectedSubtitle: 'Tus retiros se enviarán a esta dirección.',
    walletCurrentAddress: 'Dirección conectada',
    walletAddressLabel: 'Dirección TON',
    walletHint: 'Se acepta el formato user-friendly (EQ… / UQ…) o raw (0:…).',
    walletInvalidAddress: 'Dirección TON no válida',
    walletUpdate: 'Actualizar dirección',
    walletChangeAddress: 'Cambiar dirección',
    walletDisconnect: 'Desconectar',
    walletDisconnectConfirmTitle: '¿Desconectar la wallet?',
    walletDisconnectConfirmBody: 'No podrás solicitar retiros hasta que conectes una nueva dirección.',
    walletSaved: 'Wallet conectada correctamente',
    walletDisconnected: 'Wallet desconectada',
    newPaymentLink: 'Nuevo enlace de pago',
    openBot: 'Bot de Telegram',
    helpCenter: 'Centro de ayuda',
  },
  login: {
    seoTitle: 'Iniciar sesión | Plataforma de pago Telegram Stars',
    seoDescription: 'Inicia sesión en tu cuenta de Telegram Stars Payment Platform',
    signIn: 'Iniciar sesión',
    signUp: 'Registrarse',
    email: 'Correo electrónico',
    password: 'Contraseña',
    displayNameOptional: 'Nombre para mostrar (opcional)',
    displayNamePlaceholder: 'Tu nombre',
    emailPlaceholder: 'tu@email.com',
    signInButton: 'Iniciar sesión',
    signUpButton: 'Registrarse',
    signInWithGoogle: 'Iniciar sesión con Google',
    or: 'O',
    welcome: 'Bienvenido',
    subtitle: 'Inicia sesión o crea una cuenta para comenzar',
    minPasswordHint: 'Mínimo 6 caracteres',
    tipTelegram: '💡 Consejo: puedes vincular tu cuenta de Telegram en ajustes después de registrarte',
    continueWithTelegram: 'Continuar con Telegram',
    telegramAuthError: 'Error al iniciar sesión con Telegram. Inténtalo de nuevo.',
    featureInstant: 'Creación de cuenta instantánea',
    featureManage: 'Gestiona tus pagos con Telegram Stars',
    featureWithdraw: 'Retira tus fondos a TON',
    emailRequired: 'Introduce tu correo electrónico',
    emailInvalid: 'Formato de correo inválido',
    passwordRequired: 'Introduce tu contraseña',
    passwordRequiredSignup: 'Introduce una contraseña',
    passwordMinLength: 'La contraseña debe tener al menos 6 caracteres',
    genericError: 'Se ha producido un error',
    recaptchaFailed: 'Error en la verificación reCAPTCHA. Inténtalo de nuevo.',
    invalidCredentials: 'Correo o contraseña incorrectos. Si aún no tienes cuenta, créala en la pestaña «Registrarse».',
    wrongPassword: 'Contraseña incorrecta. Comprueba tu contraseña.',
    tooManyAttempts: 'Demasiados intentos. Inténtalo más tarde.',
    accountDisabled: 'Esta cuenta ha sido desactivada. Contacta con soporte.',
    authNotEnabled: 'La autenticación por correo/contraseña no está activada. Comprueba la configuración de Firebase.',
    emailInUse: 'Este correo ya está en uso. Inicia sesión con este correo.',
    googleAuthError: 'Error durante la autenticación con Google',
    popupClosed: 'Se cerró la ventana emergente. Inténtalo de nuevo.',
    popupBlocked: 'Se bloqueó la ventana emergente. Permite las ventanas emergentes e inténtalo de nuevo.',
    popupCancelled: 'Solo se permite una solicitud de ventana emergente a la vez.',
  },
  dashboard: {
    loading: 'Cargando panel...',
    overallSummary: 'Resumen general',
    lastMonth: 'Mes pasado',
    lastWeek: 'Semana pasada',
    lastYear: 'Año pasado',
    balance: 'Saldo',
    available: 'Disponible',
    totalEarned: 'Total ganado',
    fromLastMonth: 'respecto al mes pasado',
    recentPayments: 'Pagos recientes',
    last7days: 'Últimos 7 días',
    last30days: 'Últimos 30 días',
    quickActions: 'Acciones rápidas',
    createLink: 'Crear enlace',
    createLinkDesc: 'Generar un nuevo enlace de pago',
    withdraw: 'Retirar',
    withdrawDesc: 'Retira tus Stars a TON',
    invoices: 'Facturas',
    invoicesDesc: 'Ver historial de pagos',
    ledger: 'Libro mayor',
    ledgerDesc: 'Ver todas las transacciones',
    recentActivity: 'Actividad reciente',
    noRecentActivity: 'Sin actividad reciente',
    mostRecent: 'Más recientes',
    noRecentInvoices: 'Sin facturas recientes',
    allInvoices: 'Todas las facturas',
    paymentReceived: 'Pago recibido: {title}',
    withdrawalRequested: 'Retiro solicitado: {amount} {suffix}',
    transaction: 'Transacción: {amount} {suffix}',
    invoiceLabel: 'Factura #{id}',
    failedLoadBalance: 'Error al cargar el saldo',
    chartAmount: 'Importe',
  },
  invoices: {
    loading: 'Cargando...',
    allInvoices: 'Todas las facturas',
    paid: 'Pagadas',
    sent: 'Enviadas',
    created: 'Creadas',
    expired: 'Caducadas',
    filter: 'Filtrar',
    createInvoice: '+ Crear factura',
    noInvoices: 'No se encontraron facturas',
    relatedTo: 'Relacionado con:',
    paymentMode: 'Pago {mode}',
    copyLink: 'Copiar enlace',
    copyLinkTitle: 'Copiar enlace de factura',
    linkNotAvailable: 'Enlace de factura no disponible',
    linkCopied: '¡Enlace de factura copiado al portapapeles!',
    copyFailed: 'Error al copiar el enlace',
    failedLoad: 'Error al cargar las facturas',
    statusPaid: 'pagada',
    statusSent: 'enviada',
    statusCreated: 'creada',
    statusExpired: 'caducada',
    typeSingleUse: 'uso único',
    typeRecurring: 'recurrente',
  },
  createInvoice: {
    back: 'Volver',
    title: 'Crear un enlace de pago',
    subtitle: 'Genera un nuevo enlace de pago en segundos',
    successTitle: '¡Enlace de pago creado!',
    successSubtitle: 'Tu enlace de pago está listo para compartir',
    paymentLink: 'Enlace de pago:',
    integrationTitle: 'Integra este enlace en tu sitio web',
    integrationDesc: 'Nuestro bot de Telegram te guía paso a paso (API, botón HTML, redirecciones).',
    openTutorial: 'Abrir tutorial',
    testLink: 'Probar enlace',
    viewInvoices: 'Ver mis facturas',
    createNew: 'Crear un nuevo enlace',
    shareTelegram: 'Compartir en Telegram',
    paymentMode: 'Modo de pago',
    modeStars: 'Stars',
    modeEur: 'EUR (€)',
    modeUsd: 'USD ($)',
    amountInteger: 'Importe (entero)',
    amountDecimal: 'Importe (decimal)',
    amountRequired: 'Introduce un importe',
    amountIntegerError: 'El importe debe ser un entero mayor que 0',
    amountNoDecimals: 'El importe en Stars debe ser un entero (sin decimales)',
    amountMustBeInteger: 'El importe en Stars debe ser un entero',
    amountGreaterThanZero: 'El importe debe ser mayor que 0',
    titleOptional: 'Título (opcional)',
    titlePlaceholder: 'Título del pago (ej.: Pago por servicios)',
    descriptionOptional: 'Descripción (opcional)',
    descriptionPlaceholder: 'Descripción detallada del pago...',
    singleUse: 'Enlace de uso único',
    singleUseTooltip: 'Si está activado, este enlace solo puede usarse una vez. Una vez pagado, dejará de ser válido.',
    createLink: 'Crear enlace',
    cancel: 'Cancelar',
    invalidAmount: 'Importe inválido',
    starsMustBeInteger: 'El importe debe ser un entero para Stars',
    createError: 'Error al crear la factura',
  },
  ledger: {
    title: 'Libro mayor',
    typeColumn: 'Tipo',
    description: 'Historial completo de todas tus transacciones',
    loading: 'Cargando...',
    noEntries: 'No hay transacciones por el momento.',
    typePayment: 'Pago',
    typeFee: 'Comisión',
    typeNetPayment: 'Pago neto',
    typeWithdrawal: 'Retiro',
    typeAdjustment: 'Ajuste',
    amountStars: 'Importe (Stars)',
    invoiceDetail: 'Factura: {title} ({amount} Stars)',
    paidBy: 'Pagado por: {payer}',
    payerId: '(ID: {id})',
    withdrawDetail: 'Retiro: {amount} Stars (Estado: {status})',
    failedLoad: 'Error al cargar el libro mayor',
  },
  withdraws: {
    title: 'Mis solicitudes de retiro',
    newRequest: '+ Nueva solicitud',
    totalLedger: 'Total libro mayor',
    available: 'Disponible',
    pendingWithdrawals: 'Retiros pendientes',
    hold21days: 'Retención 21 días',
    payoutNote: 'Los pagos se procesan manualmente por un administrador. Se aplica una comisión del 3% al retirar.',
    forecastTitle: 'Previsión de retiros',
    loadingForecast: 'Cargando previsión...',
    noForecast: 'No hay fechas de retiro próximas',
    paymentsCount: '({count} pagos)',
    noRequests: 'No hay solicitudes de retiro por el momento.',
    createFirst: 'Crea tu primera solicitud',
    amount: 'Importe:',
    destination: 'Destino:',
    processedOn: 'Procesado el:',
    externalRef: 'Referencia externa:',
    errorLabel: 'Error:',
    rejectionReason: 'Motivo de rechazo:',
    failedLoad: 'Error al cargar los retiros',
    loading: 'Cargando...',
  },
  createWithdraw: {
    title: 'Solicitar un retiro',
    balanceSource: 'Saldo (fuente: libro mayor del backend)',
    available: 'Disponible: {amount} Stars',
    pending: 'Retiros pendientes: {amount} Stars',
    waiting: 'Retención 21 días: {amount} Stars',
    minAndFee: 'Retiro mínimo: {min} Stars · Comisión de plataforma: 3% al pagar (procesamiento manual)',
    amountLabel: 'Importe (Stars)',
    minPlaceholder: 'Mínimo: {min}',
    feeHint: 'Bruto: {gross} Stars · Comisión (3%): {fee} Stars · Recibes: {net} Stars',
    useRegistered: 'Usar mi dirección TON registrada',
    registeredAddress: 'Dirección registrada:',
    tonDestination: 'Dirección TON de destino',
    tonPlaceholder: 'EQAbc123...',
    tonFormatHint: 'Formato: EQ... o 0:... (base64 o hex)',
    createRequest: 'Crear solicitud',
    cancel: 'Cancelar',
    creating: 'Creando...',
    insufficientBalance: '⚠️ Saldo insuficiente para retirar (mínimo: {min} Stars)',
    amountMustBeInteger: 'El importe debe ser un entero positivo',
    createError: 'Error al crear la solicitud de retiro',
  },
  redirects: {
    title: 'Enlaces de redirección',
    description: 'Crea enlaces cortos que redirigen a una URL de tu elección. Compartir el enlace /r/tu-slug enviará a los visitantes a la URL configurada.',
    newRedirect: 'Nueva redirección',
    clicks: 'clics',
    unique: 'únicos',
    links: 'enlaces',
    modalTitle: 'Nueva redirección',
    slugLabel: 'Slug (identificador del enlace)',
    slugRequired: 'Campo obligatorio',
    slugPattern: 'Solo letras, números, guiones y guiones bajos',
    slugMax: 'Máx. 64 caracteres',
    slugReserved: 'Este slug está reservado. Elige otro.',
    slugPlaceholder: 'ej.: mi-sitio',
    urlLabel: 'URL de destino',
    urlInvalid: 'URL inválida',
    urlHttpOnly: 'Solo se aceptan URLs http y https.',
    urlTooLong: 'URL demasiado larga (máx. 2048 caracteres).',
    urlPlaceholder: 'https://example.com/page',
    createButton: 'Crear redirección',
    loading: 'Cargando…',
    empty: 'Sin redirecciones. Haz clic en «Nueva redirección» para crear una.',
    copyLink: 'Copiar enlace',
    linkCopied: 'Enlace copiado',
    deleteTitle: '¿Eliminar esta redirección?',
    yes: 'Sí',
    no: 'No',
    delete: 'Eliminar',
    totalClicks: 'Total de clics',
    uniqueClicks: 'Clics únicos',
    avgClicks: 'Media clics/visitante',
    loadError: 'Error al cargar las redirecciones',
    createSuccess: 'Enlace de redirección creado',
    createError: 'Error al crear la redirección',
    deleteSuccess: 'Redirección eliminada',
    deleteError: 'Error al eliminar la redirección',
  },
  adminWithdraws: {
    title: 'Administración - Solicitudes de retiro',
    filterByStatus: 'Filtrar por estado:',
    all: 'Todos',
    noRequests: 'No hay solicitudes para este estado.',
    agent: 'Agente:',
    amount: 'Importe:',
    destination: 'Destino:',
    processedOn: 'Procesado el:',
    externalRef: 'Ref. externa:',
    errorLabel: 'Error:',
    reason: 'Motivo:',
    approve: '✓ Aprobar',
    reject: '✗ Rechazar',
    markPaid: '✓ Marcar pagado',
    markFailed: '✗ Marcar fallido',
    approveConfirm: '¿Aprobar esta solicitud de retiro?',
    rejectPrompt: 'Motivo de rechazo:',
    markPaidPrompt: 'Referencia de pago externa (obligatoria — hash tx TON, ref. bancaria, etc.):',
    markPaidRequired: 'externalRef es obligatorio para confirmar un pago manual.',
    markFailedPrompt: 'Mensaje de error:',
    approveError: 'Error al aprobar el retiro',
    rejectError: 'Error al rechazar el retiro',
    updateError: 'Error al actualizar',
    failedLoad: 'Error al cargar los retiros',
    notAuthenticated: 'No autenticado',
    operationFailed: 'Operación fallida',
    loading: 'Cargando...',
  },
  redirectResolve: {
    missingSlug: 'Slug faltante',
    invalidLink: 'Enlace inválido',
    notFound: 'Enlace no encontrado',
    notFoundTitle: 'Enlace no encontrado',
    redirecting: 'Redirigiendo...',
    redirectTitle: 'Redirección',
  },
  errorBoundary: {
    title: 'Se ha producido un error',
    subtitle: 'Lo sentimos, algo salió mal. Inténtalo de nuevo.',
    goHome: 'Volver al inicio',
    reload: 'Recargar página',
    devDetails: 'Detalles del error (solo dev):',
  },
};

export const settingsApp = {
  eyebrow: 'AJUSTES',
  profile: 'Perfil',
  email: 'Correo electrónico',
  telegramId: 'ID de Telegram',
  notLinked: 'No vinculado',
  linking: 'Vinculando...',
  linkTelegram: 'Vincular mi cuenta de Telegram',
  openFromTelegram: '⚠️ Abre esta página desde Telegram para vincular tu cuenta',
  displayName: 'Nombre para mostrar',
  displayNameHint: 'El nombre para mostrar se establece al crear la cuenta',
  withdrawal: 'Retiro',
  tonAddress: 'Dirección TON de destino',
  tonAddressPlaceholder: 'EQAbc123... o 0:...',
  tonAddressHint: 'Esta dirección se usará por defecto para tus retiros',
  tonUpdated: 'Dirección TON actualizada correctamente',
  about: 'Acerca de',
  commission: 'Comisión de plataforma:',
  commissionValue: '3% en cada pago',
  minWithdrawal: 'Retiro mínimo:',
  minWithdrawalValue: '100 Stars',
  starsCurrency: 'Moneda Stars:',
  starsCurrencyValue: 'XTR',
  telegramWebAppNotAvailable: 'Telegram WebApp no disponible. Abre esta página desde Telegram.',
  telegramUserDataNotAvailable: 'Datos de usuario de Telegram no disponibles.',
  telegramLinked: '¡Cuenta de Telegram vinculada correctamente!',
  linkTelegramError: 'Error al vincular la cuenta de Telegram',
  updateError: 'Error al actualizar',
  mustBeLoggedIn: 'Debes iniciar sesión',
};
